import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import postCancelReschedule from 'Api/reschedule/postCancelReschedule';
import { useToast } from 'Store/toast';
import { useModal } from 'Store/modal';
import { useLoader } from 'Store/loader';
import { useTranslation } from 'react-i18next';

const usePostCancelReschedule = (targetScheduleId) => {
  const { t } = useTranslation('host-reschedule');
  const { id } = useParams();
  const { onResetModal } = useModal();
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      onResetModal();
      onShowLoader({ type: 'loader-primary' });

      const response = await postCancelReschedule(targetScheduleId);

      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['host-schedule-detail', id] });
      queryClient.invalidateQueries({ queryKey: ['total-request-reschedule'] });

      onResetLoader();
      onOpenToast({
        status: 'success',
        description: t('confirm_cancel.success_message'),
        duration: 5,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      onResetLoader();
      if (error.status !== 400) {
        onOpenToast({
          status: 'error',
          description: t('error.submit_failed'),
          duration: 5,
          alwaysShow: false,
        });
      } else {
        onOpenToast({
          status: 'error',
          description: error.response.data.errors[0].message,
          duration: 5,
          alwaysShow: false,
        });
      }
    },
  });
};

export default usePostCancelReschedule;
